const createApiParams = () => ({
    headers: {},
    response: true,
    queryStringParameters: {},
});

export default createApiParams;
